import intl from 'react-intl-universal';

const locales = {
    "en": require('./../../locales/en.json'),
    "ta": require('./../../locales/ta.json'),
    "si": require('./../../locales/si.json'),
    "bn": require('./../../locales/bn.json'),
    "hi": require('./../../locales/hi.json')
};

export function updateLocale(locale, callback){
    intl.init({
        currentLocale: locale ? locale:'en', // TODO: determine locale here
        locales,
    }).then(() => {
        callback && callback();
    });
};

export function strings(name, params = {}) {
    return intl.get(name, params);
};


// WEBPACK FOOTER //
// ./src/app/lib/i18n.js